import type { IconData } from '@stacksjs/iconify-core'

export const ma4x3: IconData = {
  "body": "<path fill=\"#c1272d\" d=\"M640 0H0v480h640z\"/><path fill=\"none\" stroke=\"#006233\" stroke-width=\"11.7\" d=\"M320 179.4L284.4 289l93.2-67.6H262.4l93.2 67.6z\"/>",
  "width": 640,
  "height": 480,
  "viewBox": "0 0 640 480"
}

export default ma4x3
